import { authFetch } from './client';

// Account-wide storage inventory (HS-103): what's taking up space, grouped
// project → tile, plus repository files, orphans, and recoverable deletes.
export const getAccountStorage = () => authFetch('/api/account/storage');

// PERMANENTLY reclaim leftover/orphaned storage (S3 prefixes + stale rows with no
// live project). Server recomputes the orphan set; version-level delete, so the
// space is actually freed and nothing is recoverable.
// Returns {purgedPrefixes, purgedObjects, freedBytes, purgedRecords, done}.
export const purgeAccountOrphans = () =>
  authFetch('/api/account/storage/orphans', { method: 'DELETE' });

// PERMANENTLY delete the retained delete history the inventory reports as
// `recoverableDeleted` (S3 noncurrent versions + delete markers). Cannot be undone.
// Returns {deletedObjects, deletedMarkers, freedBytes, done}.
export const purgeAccountRecycleBin = () =>
  authFetch('/api/account/storage/recycle-bin', { method: 'DELETE' });
